var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 745 742",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.864 256.66V213.334H77.0394V87.2159H285.193V16.8536H0V493.518H77.0394V283.766H217.104C236.547 271.969 257.972 262.77 280.864 256.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M743.688 497.591L744.127 14.5359H668.703V319.438L365.828 0V566.197H441.253V566.057H509.048V625.043C479.846 654.255 430.54 672.232 381.895 672.232C285.853 672.232 222.975 602.712 222.975 512.688C222.975 443.871 260.026 387.624 320.41 364.521V291.35C216.884 316.98 142.56 403.845 142.56 513.32C142.56 643.722 245.719 741.189 379.988 741.189C464.291 741.189 533.7 712.609 585.646 653.623V498.434H441.326V363.467C469.281 374.633 491.071 393.803 511.101 416.485L567.524 368.032C539.716 334.185 501.344 301.883 441.326 289.243V180.61L743.688 497.591Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ec07c02.svg";
export { ForwardRef as ReactComponent };